export enum ENV {
  PROD = "prod",
  GAMMA = "gamma",
  BETA = "beta",
  LOCAL = "localhost",
}

export const AMAZON_FEDERATE_PROD = "https://idp.federate.amazon.com";

export const isLocal = (): boolean => window.location.host.includes(ENV.LOCAL);

/** Deploy-time stage. Local and dev builds resolve the token to "test". */
export const getStage = (): string => "beta";

/**
 * Whether the current stage is Beta or local/dev.
 *
 * Gates surfaces that must NOT take effect on gamma or prod: the test-user LDAP
 * override in authService (where it would be an authorization bypass) and the
 * Admin Report pages, which ship to beta only until signed off.
 */
export const isBetaOrLocalEnv = (): boolean => {
  const normalizedStage = getStage().toLowerCase();
  return normalizedStage === ENV.BETA || normalizedStage === "test";
};
